/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIGuestRequestSearchResult
 */
export interface APIGuestRequestSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    requestNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    quantity?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    material?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestSearchResult
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIGuestRequestSearchResult
     */
    isTemp?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIGuestRequestSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGuestRequestSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIGuestRequestSearchResult
     */
    readByIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIGuestRequestSearchResult
     */
    readByEmails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIGuestRequestSearchResult
     */
    editorIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIGuestRequestSearchResult
     */
    editorEmails?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestSearchResult
     */
    filesCount?: number;
}

/**
 * Check if a given object implements the APIGuestRequestSearchResult interface.
 */
export function instanceOfAPIGuestRequestSearchResult(value: object): value is APIGuestRequestSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIGuestRequestSearchResultFromJSON(json: any): APIGuestRequestSearchResult {
    return APIGuestRequestSearchResultFromJSONTyped(json, false);
}

export function APIGuestRequestSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'requestNumber': json['request_number'] == null ? undefined : json['request_number'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'company': json['company'] == null ? undefined : json['company'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'material': json['material'] == null ? undefined : json['material'],
        'message': json['message'] == null ? undefined : json['message'],
        'status': json['status'] == null ? undefined : json['status'],
        'isTemp': json['is_temp'] == null ? undefined : json['is_temp'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'readByIds': json['read_by_ids'] == null ? undefined : json['read_by_ids'],
        'readByEmails': json['read_by_emails'] == null ? undefined : json['read_by_emails'],
        'editorIds': json['editor_ids'] == null ? undefined : json['editor_ids'],
        'editorEmails': json['editor_emails'] == null ? undefined : json['editor_emails'],
        'filesCount': json['files_count'] == null ? undefined : json['files_count'],
    };
}

export function APIGuestRequestSearchResultToJSON(value?: APIGuestRequestSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'request_number': value['requestNumber'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'company': value['company'],
        'quantity': value['quantity'],
        'material': value['material'],
        'message': value['message'],
        'status': value['status'],
        'is_temp': value['isTemp'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'read_by_ids': value['readByIds'],
        'read_by_emails': value['readByEmails'],
        'editor_ids': value['editorIds'],
        'editor_emails': value['editorEmails'],
        'files_count': value['filesCount'],
    };
}

